import { Dispatch } from 'redux';
import { Action } from './actionTypes';
import { pageLoaded } from './actions';
import * as api from 'app/shared/api';
import { ReferenceDataItem } from './state';

type CalculatorReferenceData = {
    countries: ReferenceDataItem[];
    currencies: ReferenceDataItem[];
    centres: ReferenceDataItem[];
    schools: ReferenceDataItem[];
    bookingSystems: ReferenceDataItem[];
    agents: ReferenceDataItem[];
};

export function loadPage(dispatch: Dispatch<Action>): Promise<void> {
    return fetchReferenceData('Agent')
        .then(data => {
            dispatch(pageLoaded(
                data.countries,
                data.currencies,
                data.centres,
                data.schools,
                data.bookingSystems,
                data.agents
            ));
        })
        .catch(() => {
            dispatch(pageLoaded([], [], [], [], [], []));
        });
}

function mapAgentTypeToApiType(agentType: 'Walk In' | 'E-Sale' | 'Agent'): "Agents" | "Internet Sales" | "Walk Ins" {
    switch (agentType) {
        case 'Walk In':
            return 'Walk Ins';
        case 'E-Sale':
            return 'Internet Sales';
        case 'Agent':
        default:
            return 'Agents';
    }
}

export async function fetchAgentsByType(agentType: 'Walk In' | 'E-Sale' | 'Agent'): Promise<ReferenceDataItem[]> {
    try {
        const apiAgentType = mapAgentTypeToApiType(agentType);
        const agents = await api.searchAgentsByType(apiAgentType, true);
        return agents.map(a => ({ 
            id: a.id, 
            name: a.name || `${a.agentName || ''} - ${a.officeName || ''}`.trim() 
        }));
    } catch (error) {
        console.error('Error fetching agents by type:', error);
        return [];
    }
}

async function fetchReferenceData(agentType: 'Walk In' | 'E-Sale' | 'Agent' = 'Agent'): Promise<CalculatorReferenceData> {
    const [bookingSystems, agents] = await Promise.all([
        api.getAllBookingSystems().then(bs => bs.map(b => ({ id: b.id, name: b.name }))).catch(() => []),
        fetchAgentsByType(agentType),
    ]);

    return {
        countries: [],
        currencies: [],
        centres: [],
        schools: [],
        bookingSystems,
        agents,
    };
}